import { Routes } from '@angular/router';
import { HomePage } from './home-page/home-page';
import { LoginPage } from './login-page/login-page';
import { loginGuardGuard, loginKassenzeichenGuard } from './login-guard-guard';

export const routes: Routes = [
    { path: '', component: LoginPage },
    { path: 'home', canActivate: [loginKassenzeichenGuard], component: HomePage },
    { path: 'neuerZaehlerBeantragen', canActivate: [loginKassenzeichenGuard], loadComponent: () => import('./neuer-zaehler-beantragen-page/neuer-zaehler-beantragen-page').then(m => m.NeuerZaehlerBeantragenPage) },
    { path: 'neueZaehlerAblesung/:zaehlerId', canActivate: [loginKassenzeichenGuard], loadComponent: () => import('./neue-zaehler-ablesung-page/neue-zaehler-ablesung-page').then(m => m.NeueZaehlerAblesungPage) },
    { path: 'impressum', loadComponent: () => import('./impressum-page/impressum-page').then(m => m.ImpressumPage) },
    { path: 'datenschutz', loadComponent: () => import('./datenschutz-page/datenschutz-page').then(m => m.DatenschutzPage) },
    { path: 'kontakt', loadComponent: () => import('./kontakt-page/kontakt-page').then(m => m.KontaktPage) },
];
